  let tab = document.querySelectorAll('.tab-menu-trimmer');
  let collectionList = document.querySelectorAll('.tab-collection-product');

  let printProduct = document.querySelector('.custompdp-1');
  let printProduct2 = document.querySelector('.custompdp-2');
  let printProduct3 = document.querySelector('.custompdp-3');

  tab.forEach((menu) => {
    menu.addEventListener("click", () => {
      let tabAttribute = menu.getAttribute('dataid');
    tab.forEach((item) => item.classList.remove('tab-color'));
    menu.classList.add('tab-color');
      collectionList.forEach((collectionProduct) => {
        let collectionAttribute = collectionProduct.getAttribute('id');
        
        if (tabAttribute === collectionAttribute) {
          collectionProduct.style.display = 'block';
          collectionProduct.classList.add('collection-index');
        } else {
          collectionProduct.style.display = 'none';
          collectionProduct.classList.remove('collection-index');
        }
      });
    });
  });

if (window.innerWidth >= 480) {
    let data = document.querySelectorAll('.meta-image-pdp');
    data.forEach((i) => {
        let nearParent = i.closest('.custom-card');
        if (nearParent) {
            nearParent.style.padding = '0';
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
  function initializeSlider() {
    const isMobile = window.innerWidth <= 1024;
    const printDiv = document.querySelector(".custom---trimmers--6");
    const appendDiv = document.querySelector(".mobile-product-slider");
    console.log(appendDiv, "appendDiv");

    if (isMobile && appendDiv) {
      if (printDiv) {
        printDiv.insertAdjacentElement("afterend", appendDiv);
      } else {
        document.body.appendChild(appendDiv);
      }
    }
  }

  initializeSlider();
});


  $(document).ready(function () {
    $('.page-banner-section img:first').show();
    $('.page-banner-section img').hide();

    function initializeSlider() {
      if (!$('.page-banner-section').hasClass('slick-initialized')) {
        $('.page-banner-section img').show(); 

        $('.page-banner-section').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false
        });

      $('.page-banner-section > *').css("display", "block");

      }
    }
      initializeSlider();
  });

$(".video-play-btn").each(function () {
  const playButton = $(this);
  const videoContainer = playButton.closest(".videos-alignment");
  const video = videoContainer.find("video").get(0);
  const pauseButton = videoContainer.find(".video-paused-btn");

  let hideControlsTimeout;

  function hideControls() {
    playButton.hide();
    pauseButton.hide();
  }

  function resetHideControlsTimeout() {
    clearTimeout(hideControlsTimeout);
    hideControlsTimeout = setTimeout(() => {
      if (!video.paused) {
        pauseButton.hide();
      }
    }, 3000);
  }

  playButton.css("display", "flex");

  playButton.on("click", function () {
    $("video").each(function () {
      if (this !== video) {
        this.pause();
        $(this).closest(".videos-alignment").find(".video-play-btn").css("display", "flex");
        $(this).closest(".videos-alignment").find(".video-paused-btn").hide();
      }
    });

    if (video.paused) {
      video.play();
      playButton.hide();
      pauseButton.css("display", "flex");
      resetHideControlsTimeout();
    }
  });

  pauseButton.on("click", function () {
    if (!video.paused) {
      video.pause();
      playButton.css("display", "flex");
      pauseButton.hide();
      clearTimeout(hideControlsTimeout);
    }
  });

  videoContainer.on("mouseenter", function () {
    if (video.paused) {
      playButton.css("display", "flex");
      pauseButton.hide();
    } else {
      pauseButton.css("display", "flex");
      playButton.hide();
    }
    clearTimeout(hideControlsTimeout);
  });

  videoContainer.on("mouseleave", function () {
    resetHideControlsTimeout();
  });

  $(video).on("play", function () {
    playButton.hide();
    pauseButton.css("display", "flex");
    resetHideControlsTimeout();
  });

  $(video).on("pause", function () {
    playButton.css("display", "flex");
    pauseButton.hide();
    clearTimeout(hideControlsTimeout);
  });

  $(video).on("mousemove click", function () {
    if (video.paused) {
      playButton.css("display", "flex");
      pauseButton.hide();
    } else {
      pauseButton.css("display", "flex");
      playButton.hide();
    }
    resetHideControlsTimeout();
  });
});


